import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { rootStore } from '../../../mobx/rootStore';
import { ProjectName, ProjectTitle } from './styles';
import { useMobileDevice } from '../../../global/useMobile';
import { ProjectModel } from '../../../mobx/models/project';
import ProjectIconAvatar from '../../ProjectIconAvtar/projectIconAvtar';
import { ICON_COLORS, PROJECT_ICON_TYPE } from '../../../global/constants';

interface ProjectNameInterface {
  item: ProjectModel;
  onCloseNavbar?: () => void;
}
const ProjectItem: React.FC<ProjectNameInterface> = (props) => {
  const { item, onCloseNavbar } = props;
  //Other variable
  const history = useHistory();
  const location = useLocation();
  const isProject = location?.pathname?.startsWith(`/projects/details/${item?.id}`);
  const isMobile = useMobileDevice();

  const onClickProject = useCallback(() => {
    rootStore.projectStore.setCurrentProject(item?.id);
    history.push(`/projects/details/${item?.id}/tasks`);
    onCloseNavbar?.();
  }, [history, item?.id, onCloseNavbar]);

  return (
    <>
      <ProjectName
        onClick={onClickProject}
        isActive={isProject}
        className={isProject ? 'active-navbar-item-menu ' : 'navbar-menu-name'}>
        <ProjectIconAvatar
          size={isMobile ? 24 : 20}
          type={item?.icon?.type ?? PROJECT_ICON_TYPE.DEFAULT}
          reference={item?.icon?.reference || ''}
          backgroundColor={ICON_COLORS[item?.icon?.color || 1]}
          projectName={item?.name}
          borderRadius={isMobile ? '6px' : '4px'}
          iconSize={isMobile ? 16 : 13}
          isClickable={false}
        />
        <ProjectTitle>{item?.name}</ProjectTitle>
      </ProjectName>
    </>
  );
};

export { ProjectItem };
